// export { default as Copy } from "./modules/Copy";
export { default as Cursor } from "./modules/Cursor";
export { default as Images } from "./modules/ImageLoad";
export { default as Load } from "./modules/Load";
export { default as Marquee } from "./modules/Marquee";
export { default as Preloader } from "./modules/Preloader";
export { default as Slides } from "./modules/Slides";
export { default as Time } from "./modules/Time";
export { default as Year } from "./modules/Year";
